import { isMobile } from '../utilities/check-device-resolution';

const toggleFilter = () => {
  const $button = $('.js-filters-button');
  const $filters = $('.js-filters');

  // Toggle Main Filters
  $button.on('click', function() {
    const $this = $(this);

    if (isMobile()) {
      $this.toggleClass('is-active');
      $filters.stop().slideToggle();
    }
  });

  // Toggle Filter
  $(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
    const $this = $(this);

    if (isMobile()) {
      $this
        .parent()
          .parent()
            .toggleClass('is-expanded');
    }
  });
}

toggleFilter();
